(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cah-pdp-enhancements"] && !Shopify.designMode) return;
  try {
    function cahDecodeTranslationStrings(strings) {
  const decoder = document.createElement('textarea');
  return Object.fromEntries(Object.entries(strings).map(([key, value]) => {
    decoder.innerHTML = String(value);
    return [key, decoder.value];
  }));
}

  if (!customElements.get('cah-pdp-tools')) {
    customElements.define('cah-pdp-tools', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root || this.initialized) return;
        this.initialized = true;
        this.strings = cahDecodeTranslationStrings(JSON.parse(this.querySelector('[data-cah-strings]').textContent));
        this.sizeChosen = this.dataset.requireSize !== 'true';
        this.chosenSize = null;
        this.bar = this.querySelector('.cah-pdp-sticky');
        this.dialog = this.querySelector('dialog');
        this.controller = new AbortController();
        const options = { capture: true, signal: this.controller.signal };
        this.root.addEventListener('click', (event) => this.onClick(event), options);
        this.root.addEventListener('change', (event) => this.onChange(event), options);
        this.root.addEventListener('submit', (event) => this.guard(event), options);
        this.dialog.querySelector('.cah-size-close').addEventListener('click', () => this.dialog.close(), { signal: this.controller.signal });
        this.dialog.addEventListener('close', () => this.guideTrigger?.focus(), { signal: this.controller.signal });
        this.bar.querySelector('.cah-pdp-change').addEventListener('click', () => this.focusOptions(), { signal: this.controller.signal });
        this.bar.querySelector('.cah-pdp-sticky__add').addEventListener('click', () => {
          if (!this.sizeChosen) return this.focusOptions(true);
          const state = this.state();
          if (state.ready) state.button.click();
        }, { signal: this.controller.signal });
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled','aria-disabled','value'] });
        this.visibility = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.passedButton = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.updateVisibility();
        });
        const button = this.root.querySelector('[name="add"]');
        if (button) this.visibility.observe(button);
        this.resize = new ResizeObserver(() => this.updateSpacing());
        this.resize.observe(this.bar);
        this.overlayObserver = new MutationObserver(() => this.updateVisibility());
        this.overlayObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class','open','aria-hidden'] });
        document.documentElement.classList.add('cah-pdp-enhanced');
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.resize?.disconnect();
        this.overlayObserver?.disconnect();
        document.documentElement.classList.remove('cah-pdp-enhanced');
        document.documentElement.style.removeProperty('--cah-sticky-height');
        this.initialized = false;
      }

      state() {
        const button = this.root.querySelector('[name="add"]');
        const form = button?.closest('form');
        const input = form?.querySelector('input[name="id"]');
        let variant = null;
        const picker = this.root.querySelector('variant-selects');
        try { variant = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { variant = null; }
        const valid = picker ? !!variant && String(variant.id) === input?.value : !!input?.value;
        const busy = button?.getAttribute('aria-disabled') === 'true';
        const ready = !!button && !!input && valid && variant?.available !== false && !input.disabled && !button.disabled && !busy && !this.pending;
        return { button, input, variant, ready, busy, valid };
      }

      getSizeField() {
        return [...this.root.querySelectorAll('variant-selects fieldset')].find((field) => {
          const input = field.querySelector('input[type="radio"]');
          return /^size(?:-|$)/i.test(input?.name || '');
        });
      }

      onClick(event) {
        const guide = event.target.closest('.cah-size-link');
        if (guide) {
          this.openGuide(guide);
          return;
        }
        const input = event.target.closest('input[type="radio"]');
        if (input && input.closest('fieldset') === this.getSizeField()) {
          this.sizeChosen = true;
          this.chosenSize = input.value;
          this.schedule();
        }
        if (event.target.closest('[name="add"]')) this.guard(event);
      }

      onChange(event) {
        if (!event.target.closest('variant-selects')) return;
        if (event.target.closest('fieldset') === this.getSizeField()) {
          this.sizeChosen = true;
          this.chosenSize = event.target.value;
        }
        this.pending = true;
        this.pendingPicker = this.root.querySelector('variant-selects');
        this.schedule();
      }

      guard(event) {
        const state = this.state();
        if (event.type === 'submit' && event.target !== state.button?.form) return;
        if (!this.sizeChosen || this.pending || !state.ready) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (!this.sizeChosen) this.focusOptions(true);
        }
      }

      schedule() {
        if (this.scheduled) return;
        this.scheduled = true;
        requestAnimationFrame(() => {
          this.scheduled = false;
          if (this.isConnected) this.update();
        });
      }

      update() {
        const field = this.getSizeField();
        if (field) {
          const selected = field.querySelector('input:checked');
          if (this.chosenSize && selected?.value !== this.chosenSize) {
            this.sizeChosen = false;
            this.chosenSize = null;
          }
          if (this.dataset.requireSize === 'true') {
            field.toggleAttribute('data-cah-size-pending', !this.sizeChosen);
            let hint = field.querySelector('.cah-size-prompt');
            if (!hint) {
              hint = document.createElement('p');
              hint.className = 'cah-size-prompt';
              hint.id = `CahSizePrompt-${this.root.dataset.section}`;
              hint.setAttribute('role','status');
              field.append(hint);
              field.setAttribute('aria-describedby', hint.id);
            }
            this.setText(hint, this.sizeChosen ? this.strings.confirmed.replace('__SIZE__',this.chosenSize || selected?.value || '') : this.strings.prompt);
          }
          const source = this.root.querySelector('[data-cah-size-guide]');
          if (source && !field.querySelector('.cah-size-link')) {
            const link = document.createElement('button');
            link.type = 'button';
            link.className = 'cah-size-link';
            link.textContent = this.strings.guide;
            link.setAttribute('aria-haspopup','dialog');
            field.querySelector('legend')?.append(link);
          }
          const values = [...field.querySelectorAll('input')].map((input) => input.value);
          if (this.dataset.requireSize !== 'true' && values.some((value) => /oz/i.test(value))) {
            const legend = field.querySelector('legend');
            if (legend && legend.childNodes[0]?.nodeType === Node.TEXT_NODE && legend.childNodes[0].textContent.trim() !== this.strings.capacity) legend.childNodes[0].textContent = this.strings.capacity;
          }
          if (values.length === 1) {
            const label = field.querySelector('label');
            if (label && label.tagName === 'LABEL') {
              const text = document.createElement('span');
              text.className = 'cah-one-size';
              text.textContent = values[0];
              label.replaceWith(text);
              const onlyInput = field.querySelector('input');
              if (onlyInput) onlyInput.hidden = true;
            }
          }
        }
        const state = this.state();
        if (this.pending && this.pendingPicker !== this.root.querySelector('variant-selects')) this.pending = false;
        const current = this.state();
        const text = current.button?.querySelector('span');
        if (text && !this.pending && current.valid && !current.button.disabled && !current.busy) this.setText(text, this.sizeChosen ? this.strings.add : this.strings.choose);
        const stickyButton = this.bar.querySelector('.cah-pdp-sticky__add');
        this.setText(stickyButton, !this.sizeChosen ? this.strings.choose : this.pending || current.busy ? this.strings.updating : current.ready ? this.strings.add : current.variant?.available === false ? this.strings.soldOut : this.strings.unavailable);
        const blocked = this.sizeChosen && !current.ready;
        if (stickyButton.disabled !== blocked) stickyButton.disabled = blocked;
        const selection = this.bar.querySelector('.cah-pdp-sticky__selection');
        const chosen = current.variant?.options?.filter((option) => option !== 'Default Title').join(' / ');
        this.setText(selection, !this.sizeChosen ? this.strings.prompt : chosen || '');
        const price = this.root.querySelector('.price--on-sale .price-item--sale') || this.root.querySelector('[id^="price-"] .price-item--regular');
        this.setText(this.bar.querySelector('.cah-pdp-sticky__price'), current.valid && !this.pending ? price?.textContent.trim() || '' : '');
        const hasChoices = [...this.root.querySelectorAll('variant-selects fieldset')].some((option) => option.querySelectorAll('input[type="radio"]').length > 1) || [...this.root.querySelectorAll('variant-selects select')].some((option) => option.options.length > 1);
        const change = this.bar.querySelector('.cah-pdp-change');
        if (change.hidden === hasChoices) change.hidden = !hasChoices;
        this.updateThumbnail(current);
        this.updateVisibility();
      }

      updateThumbnail(current) {
        const image = this.bar.querySelector('.cah-pdp-sticky__image');
        if (!image) return;
        if (this.pending || !current.valid) {
          image.hidden = true;
          return;
        }
        const featured = current.variant?.featured_image;
        const source = (typeof featured === 'string' ? featured : featured?.src) || current.variant?.featured_media?.preview_image?.src || image.dataset.fallbackSrc;
        if (!source) {
          image.hidden = true;
          return;
        }
        try {
          const url = new URL(source, window.location.origin);
          if (url.protocol !== 'https:' && url.protocol !== 'http:') {
            image.hidden = true;
            return;
          }
          url.searchParams.set('width', '128');
          if (image.src !== url.href) image.src = url.href;
          image.hidden = false;
        } catch {
          image.hidden = true;
        }
      }

      setText(node, value) {
        if (node && node.textContent !== value) node.textContent = value;
      }

      focusOptions(sizeOnly = false) {
        const field = sizeOnly ? this.getSizeField() : this.root.querySelector('variant-selects');
        const target = field?.querySelector('input:checked, select, input') || this.root.querySelector('[name="add"]');
        (field || target)?.scrollIntoView({ block: 'center', behavior: 'auto' });
        target?.focus({ preventScroll: true });
      }

      openGuide(trigger) {
        const source = this.root.querySelector('[data-cah-size-guide] .accordion__content');
        if (!source) return;
        this.guideTrigger = trigger;
        if (typeof this.dialog.showModal !== 'function') {
          source.closest('details').open = true;
          source.scrollIntoView({ block: 'center' });
          source.closest('details').querySelector('summary')?.focus();
          return;
        }
        const clone = source.cloneNode(true);
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        this.dialog.querySelector('.cah-size-content').replaceChildren(clone);
        this.dialog.showModal();
      }

      updateVisibility() {
        const overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, body.overflow-hidden, body.overflow-hidden-mobile, [data-essential-cart-element="cart-drawer-overlay"][aria-hidden="false"]');
        const hidden = !this.passedButton || !!overlay;
        if (this.bar.hidden !== hidden) this.bar.hidden = hidden;
        this.updateSpacing();
      }

      updateSpacing() {
        const value = this.bar.hidden ? '0px' : `${Math.ceil(this.bar.getBoundingClientRect().height)}px`;
        if (document.documentElement.style.getPropertyValue('--cah-sticky-height') !== value) document.documentElement.style.setProperty('--cah-sticky-height',value);
      }
    });
  }
if (!customElements.get('cah-pdp-polish')) {
  customElements.define('cah-pdp-polish', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.root = this.closest('product-info[data-cah-pdp]');
      if (!this.root) return;
      this.started = true;
      this.data = JSON.parse(this.querySelector('[data-cah-polish]').textContent);
      this.data.strings = cahDecodeTranslationStrings(this.data.strings);
      this.galleryScope = this.root.querySelector('.product__media-wrapper');
      this.serverCount = Number(this.root.dataset.cahReviewCount || 0);
      this.galleryObserver = new MutationObserver(() => this.schedule());
      if (this.galleryScope) this.galleryObserver.observe(this.galleryScope, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','data-pmslider-slide-active'] });
      this.reviewObserver = new MutationObserver(() => this.schedule());
      this.reviewObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
      this.update();
    }

    disconnectedCallback() {
      this.galleryObserver?.disconnect();
      this.reviewObserver?.disconnect();
      this.started = false;
    }

    schedule() {
      if (this.scheduled) return;
      this.scheduled = true;
      requestAnimationFrame(() => {
        this.scheduled = false;
        if (this.isConnected) this.update();
      });
    }

    imageKey(src) {
      if (!src) return '';
      try {
        return decodeURIComponent(new URL(src, location.origin).pathname).replace(/_(?:\d+x\d*|\d*x\d+)(?=\.[^/.]+$)/i, '');
      } catch { return ''; }
    }

    caption(media, index) {
      const strings = this.data.strings;
      const alt = String(media?.alt || '').toLowerCase();
      if (media?.type === 'video' || media?.type === 'external_video') return strings.video;
      if (['46479156052071','46479155658855'].includes(String(media?.id))) return strings.sample;
      if (/size\s*(chart|guide)/i.test(alt)) return strings.chart;
      const colour = [...this.data.colours].sort((a,b) => b.length-a.length).find((value) => alt.includes(value.toLowerCase()));
      let view = '';
      if (alt.includes('front') && alt.includes('back')) view = strings.frontBack;
      else if (alt.includes('back')) view = strings.back;
      else if (alt.includes('front')) view = strings.front;
      else if (/interior|shown open/.test(alt)) view = strings.interior;
      else if (alt.includes('detail')) view = strings.detail;
      return [colour,view].filter(Boolean).join(' · ') || strings.image.replace('__NUMBER__',String(index+1));
    }

    update() {
      this.updateGallery();
      const counts = [...document.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews], .jdgm-rev-widg[data-number-of-reviews]')]
        .filter((element) => element.closest('.jdgm-widget')?.getAttribute('data-id') === this.root.dataset.productId)
        .map((element) => Number(element.getAttribute('data-number-of-reviews')) || 0);
      const count = Math.max(this.serverCount,...counts);
      if (this.root.dataset.cahReviewCount !== String(count)) this.root.dataset.cahReviewCount = String(count);
      document.querySelectorAll('.jdgm-review-widget').forEach((widget) => {
        if (widget.getAttribute('data-id') !== this.root.dataset.productId) return;
        const section = widget.closest('.shopify-section');
        if (section && !section.contains(this.root) && section.querySelectorAll('.shopify-app-block').length === 1) {
          section.setAttribute('data-cah-empty-review-section','');
          if (section.hidden !== (count === 0)) section.hidden = count === 0;
        }
      });
    }

    updateGallery() {
      const gallery = this.galleryScope?.querySelector('.pmslider-root');
      const dots = gallery?.querySelector('.pmslider-dots--type-thumbs');
      if (!dots) return;
      dots.setAttribute('role','group');
      dots.setAttribute('aria-label',this.data.strings.gallery);
      dots.querySelectorAll('.pmslider-dots_dot-wrapper').forEach((wrapper,index) => {
        const dot = wrapper.querySelector('.pmslider-dots_dot');
        if (!dot) return;
        const image = dot.querySelector('img');
        const key = this.imageKey(image?.getAttribute('src'));
        const media = this.data.media.find((item) => key && this.imageKey(item.src) === key) || this.data.media[index];
        const alt = media?.alt || this.data.strings.image.replace('__NUMBER__',String(index+1));
        const label = this.data.strings.view.replace('__NUMBER__',String(index+1)).replace('__DESCRIPTION__',alt);
        let button = wrapper.querySelector('button.cah-gallery-thumb');
        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'cah-gallery-thumb';
          wrapper.insertBefore(button,dot);
          button.append(dot);
        }
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label',label);
        const current = String(dot.classList.contains('pmslider-dots_dot--current'));
        if (button.getAttribute('aria-current') !== current) button.setAttribute('aria-current',current);
        if (image?.alt) image.alt = '';
        wrapper.querySelectorAll('.cah-gallery-caption').forEach((caption) => caption.remove());
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cah-shipping-sync"] && !Shopify.designMode) return;
  try {
    (() => {
  function start() {
    const template = document.getElementById('cah-shipping-progress-template');
    const copyElement = document.getElementById('cah-shipping-copy');
    if (!template || !copyElement || window.cahShippingSync) return;
    window.cahShippingSync = true;
    const decoder = document.createElement('textarea');
    const copy = Object.fromEntries(Object.entries(JSON.parse(copyElement.textContent)).map(([key, value]) => {
      decoder.innerHTML = value;
      return [key, decoder.value];
    }));
    let cart = null;
    let requestNumber = 0;
    let frame = 0;
    let timer = 0;
    const selector = '[data-cah-shipping-progress], [data-essential-cart-element="reward-goal-bar-wrapper"]';
    function shippingOnly() {
      try {
        const embed = document.querySelector('essential-cart-app-embed');
        const configs = JSON.parse(embed?.getAttribute('upsell-app-data') || '{}').carts || [];
        const drawers = configs.filter((item) => item.isPublished && item.cartType === 'CART_DRAWER');
        return drawers.length > 0 && drawers.every((item) => {
          const rewards = (item.rewards || []).filter((reward) => reward.isEnabled);
          return rewards.length > 0 && rewards.every((reward) => reward.tiers?.length > 0 && reward.tiers.every((tier) => tier.RewardTierType === 'SHIPPING_DISCOUNT'));
        });
      } catch { return false; }
    }
    function state(data) {
      if (!data || !Number.isFinite(data.total_price)) return { text: copy.unavailable, show: false, total: 0, empty: false };
      const total = Math.max(0, data.total_price);
      if (data.currency !== 'USD') return { text: copy.currency, show: false, total, empty: data.item_count === 0 };
      const applications = [...(data.cart_level_discount_applications || [])];
      for (const item of data.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) applications.push(allocation.discount_application || allocation);
      }
      const welcome = applications.some((discount) => discount.target_type === 'line_item' && discount.value_type === 'percentage' && Number(discount.value) === 15);
      const hasCode = (data.discount_codes || []).some((discount) => discount.applicable !== false);
      const discounted = Number(data.total_discount) > 0 || hasCode || applications.some((discount) => discount.target_type === 'line_item' && Number(discount.total_allocated_amount) > 0);
      let text;
      if (welcome) text = copy.welcome;
      else if (discounted) text = copy.discount;
      else if (total >= 7500) text = copy.qualified;
      else {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format((7500 - total) / 100);
        text = copy.remaining.replace('__AMOUNT__', amount);
      }
      return { text, show: !welcome && !discounted, total, empty: data.item_count === 0 };
    }
    function render() {
      frame = 0;
      if (shippingOnly()) {
        document.querySelectorAll('[data-essential-cart-element="reward-goal-bar-wrapper"]').forEach((wrapper) => {
          wrapper.setAttribute('data-cah-shipping-source', '');
          if (!wrapper.querySelector('[data-cah-shipping-progress]')) wrapper.append(template.content.cloneNode(true));
        });
      }
      const result = state(cart);
      document.querySelectorAll('[data-cah-shipping-progress]').forEach((box) => {
        if (box.hidden !== result.empty) box.hidden = result.empty;
        const text = box.querySelector('[data-cah-shipping-message]');
        if (text.textContent !== result.text) text.textContent = result.text;
        const progress = box.querySelector('[data-cah-shipping-meter]');
        if (progress.hidden !== !result.show) progress.hidden = !result.show;
        const value = Math.min(7500, result.total);
        if (progress.value !== value) progress.value = value;
      });
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(render); }
    function accept(data) {
      if (!data || !Number.isFinite(data.total_price)) return refresh();
      requestNumber += 1;
      cart = data;
      schedule();
    }
    async function refresh() {
      const current = ++requestNumber;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        const data = await response.json();
        if (current !== requestNumber) return;
        cart = data;
      } catch {
        if (current !== requestNumber) return;
        cart = null;
      }
      schedule();
    }
    function queueRefresh() { clearTimeout(timer); timer = setTimeout(refresh, 100); }
    document.addEventListener('essential-cart:update', (event) => accept(event.detail));
    document.addEventListener('essential-cart:open', queueRefresh);
    window.addEventListener('cart:updated', (event) => event.detail?.cart ? accept(event.detail.cart) : queueRefresh());
    document.addEventListener('cart:refresh', queueRefresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) queueRefresh(); });
    window.addEventListener('pageshow', (event) => { if (event.persisted) queueRefresh(); });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, queueRefresh);
    const observer = new MutationObserver((records) => {
      if (records.some((record) => record.target.nodeType === 1 && record.target.closest('[data-essential-cart-element="reward-goal-bar-wrapper"]') || [...record.addedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    const initial = window.essentialCartApi?.getCartData?.();
    if (initial) accept(initial);
    schedule();
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
